import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ErrorCodes, SuccessCodes } from '@commutifi-fe/constants';
import { IntlMessageKeys, useComponentIntl } from '../locales';
import { getCommutifiErrorCode, getHttpStatusFromError } from '@commutifi-fe/utils';

// This object is defined so we can use typescript to give an error if a value
// is added to the enum but not here
const errorKeyObj: Record<ErrorCodes, IntlMessageKeys<'errors'>> = {
  [ErrorCodes.InvalidGrant]: 'error.stripe.authorize.invalidGrant',
  [ErrorCodes.AccessDenied]: 'error.stripe.authorize.accessDenied',
  [ErrorCodes.ArcOAuthError]: 'settings.integrations.leed.connect.error',
  [ErrorCodes.StripeOAuthError]: 'settings.integrations.stripeConnect.notifications.error'
};
const errorKeyMap = new Map<string, IntlMessageKeys<'errors'>>(Object.entries(errorKeyObj));

// This object is defined so we can use typescript to give an error if a value
// is added to the enum but not here
const successKeyObj: Record<SuccessCodes, IntlMessageKeys<'errors'>> = {
  [SuccessCodes.ArcOauth]: 'settings.integrations.leed.connect.success'
};
const successKeyMap = new Map<string, IntlMessageKeys<'errors'>>(Object.entries(successKeyObj));
export const useCommutifiErrorMessages = () => {
  const $ = _c(10);
  const intl = useComponentIntl("errors");
  let t0;
  if ($[0] !== intl) {
    t0 = errorCode => intl.formatMessage({
      id: `error.commutifi.${errorCode ?? 500}`,
      defaultMessage: intl.formatMessage({
        id: "error.commutifi.500"
      })
    });
    $[0] = intl;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const translate = t0;
  let t1;
  if ($[2] !== intl) {
    t1 = (success, fallbackMessage) => {
      if (!success) {
        return fallbackMessage;
      }
      const messageId = successKeyMap.get(success);
      if (!messageId) {
        return fallbackMessage;
      }
      return intl.formatMessage({
        id: messageId
      });
    };
    $[2] = intl;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const translateCommutifiSuccess = t1;
  let t2;
  if ($[4] !== intl) {
    t2 = (error, fallbackMessage_0) => {
      const errorStr = typeof error === "string" ? error : null;
      if (errorStr) {
        return intl.formatMessage({
          id: errorKeyMap.get(errorStr) || "error.commutifi.500"
        });
      }
      const commutifiCode = getCommutifiErrorCode(error);
      const httpStatus = getHttpStatusFromError(error);
      const errorCode_0 = commutifiCode ?? httpStatus ?? 500;
      if (!commutifiCode && fallbackMessage_0) {
        return fallbackMessage_0;
      }
      return intl.formatMessage({
        id: `error.commutifi.${errorCode_0}`,
        defaultMessage: fallbackMessage_0 ?? intl.formatMessage({
          id: "error.commutifi.500"
        })
      });
    };
    $[4] = intl;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const translateCommutifiError = t2;
  let t3;
  if ($[6] !== translate || $[7] !== translateCommutifiError || $[8] !== translateCommutifiSuccess) {
    t3 = {
      translate,
      getCommutifiErrorCode,
      translateCommutifiError,
      translateCommutifiSuccess
    };
    $[6] = translate;
    $[7] = translateCommutifiError;
    $[8] = translateCommutifiSuccess;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};